import { Database } from "src/supabase.types";
import { TAGS } from "../constants";
import { Coupon, CouponDetails } from "../types";
import { api } from "./api";

type CreateCouponArgs = Omit<
  Database["public"]["Tables"]["coupons"]["Insert"],
  "stripe_id"
> & {
  stripe_product_id: string;
};

type UpdateCouponArgs = Database["public"]["Tables"]["coupons"]["Update"];

export const couponsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCoupons: builder.query<
      {
        records: CouponDetails[];
        count: number;
      },
      { from: number; to: number; invoice_id?: string }
    >({
      query: (params) => ({
        url: "/api/coupons",
        method: "GET",
        params,
      }),
      providesTags: [TAGS.COUPONS],
    }),
    getCouponsForProduct: builder.query<Coupon[], string>({
      query: (productId) => ({
        url: `/api/coupons/product/${productId}`,
        method: "GET",
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.PRODUCT_COUPONS, id: args },
      ],
    }),
    createCoupon: builder.mutation<Coupon, CreateCouponArgs>({
      query: (body) => ({
        url: "/api/coupons",
        method: "POST",
        body,
      }),
      invalidatesTags: [TAGS.COUPONS],
    }),
    updateCoupon: builder.mutation<Coupon, UpdateCouponArgs>({
      query: ({ id, ...body }) => ({
        url: `/api/coupons/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [TAGS.COUPONS],
    }),
  }),
});

export const {
  useGetCouponsQuery,
  useCreateCouponMutation,
  useUpdateCouponMutation,
  useGetCouponsForProductQuery,
} = couponsApi;
